import { connectionsConstants } from "../_constants";
import { connectionsServices } from "../_services";
import { alertActions } from ".";

export const connectionsActions = {
  getAllConnections,
  getTopCardConnections,
  fetchActiveSourceAndDestination,
  addConnection,
  getConnectionById,
  getConnectionByWorkspaceId,
  getEndpointsByConnectionId,
  connfiqureConnectionById,
  editConnectionById,
  getSlackListIntegration,
  getBitbucketIntegration,
  searchConnections,
  getConnectionsFilters,
  applyConnectionsFilters
};

function getAllConnections(offset, limit) {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.getAllConnections(offset, limit).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: connectionsConstants.GET_ALL_CONNECTIONS_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.GET_ALL_CONNECTIONS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: connectionsConstants.GET_ALL_CONNECTIONS_FAILURE, error };
  }
}

function getTopCardConnections() {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.getTopCardConnections().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: connectionsConstants.GET_TOP_CARDS_CONNECTIONS_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.GET_TOP_CARDS_CONNECTIONS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: connectionsConstants.GET_TOP_CARDS_CONNECTIONS_FAILURE,
      error,
    };
  }
}
function fetchActiveSourceAndDestination() {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.fetchActiveSourceAndDestination().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return {
      type: connectionsConstants.GET_FETCH_ACTIVE_SOURCE_DESTINATION_REQUEST,
    };
  }
  function success(data) {
    return {
      type: connectionsConstants.GET_FETCH_ACTIVE_SOURCE_DESTINATION_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: connectionsConstants.GET_FETCH_ACTIVE_SOURCE_DESTINATION_FAILURE,
      error,
    };
  }
}

function addConnection(formData) {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.addConnection(formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: connectionsConstants.ADD_CONNECTION_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.ADD_CONNECTION_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: connectionsConstants.ADD_CONNECTION_FAILURE, error };
  }
}

function getConnectionById(connectionId) {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.getConnectionById(connectionId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: connectionsConstants.GET_CONNECTION_BY_ID_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.GET_CONNECTION_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: connectionsConstants.GET_CONNECTION_BY_ID_FAILURE, error };
  }
}
function getConnectionByWorkspaceId(workspaceId) {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.getConnectionByWorkspaceId(workspaceId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return {
      type: connectionsConstants.GET_CONNECTION_BY_WORKSPACE_ID_REQUEST,
    };
  }
  function success(data) {
    return {
      type: connectionsConstants.GET_CONNECTION_BY_WORKSPACE_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: connectionsConstants.GET_CONNECTION_BY_WORKSPACE_ID_FAILURE,
      error,
    };
  }
}

function getEndpointsByConnectionId(connectionId) {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.getEndpointsByConnectionId(connectionId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return {
      type: connectionsConstants.GET_ENDPOINTS_BY_CONNECTION_ID_REQUEST,
    };
  }
  function success(data) {
    return {
      type: connectionsConstants.GET_ENDPOINTS_BY_CONNECTION_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: connectionsConstants.GET_ENDPOINTS_BY_CONNECTION_ID_FAILURE,
      error,
    };
  }
}

function connfiqureConnectionById(connectionId, formData) {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.connfiqureConnectionById(connectionId, formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return {
      type: connectionsConstants.CONFIGURE_CONNECTION_BY_CONNECTION_ID_REQUEST,
    };
  }
  function success(data) {
    return {
      type: connectionsConstants.CONFIGURE_CONNECTION_BY_CONNECTION_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: connectionsConstants.CONFIGURE_CONNECTION_BY_CONNECTION_ID_FAILURE,
      error,
    };
  }
}

function editConnectionById(connectionId, formData) {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.editConnectionById(connectionId, formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: connectionsConstants.EDIT_CONNECTION_BY_ID_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.EDIT_CONNECTION_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: connectionsConstants.EDIT_CONNECTION_BY_ID_FAILURE, error };
  }
}

function getSlackListIntegration() {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.getSlackListIntegration().then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: connectionsConstants.FETCH_SLACK_LIST_INTEGRATION_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.FETCH_SLACK_LIST_INTEGRATION_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: connectionsConstants.FETCH_SLACK_LIST_INTEGRATION_FAILURE,
      error,
    };
  }
}

function getBitbucketIntegration() {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.getBitbucketIntegration().then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: connectionsConstants.FETCH_BITBUCKET_INTEGRATION_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.FETCH_BITBUCKET_INTEGRATION_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: connectionsConstants.FETCH_BITBUCKET_INTEGRATION_FAILURE,
      error,
    };
  }
}

function searchConnections(search, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.searchConnections(search, offset, limit).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: connectionsConstants.GET_ALL_CONNECTIONS_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.GET_ALL_CONNECTIONS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: connectionsConstants.GET_ALL_CONNECTIONS_FAILURE, error };
  }
}

function getConnectionsFilters() {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.getConnectionsFilters().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: connectionsConstants.GET_CONNECTIONS_FILTERS_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.GET_CONNECTIONS_FILTERS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: connectionsConstants.GET_CONNECTIONS_FILTERS_FAILURE,
      error,
    };
  }
}

function applyConnectionsFilters(
  source,
  destination,
  user,
  workspace,
  startDate,
  endDate,
  search = "",
  offset = 0,
  limit = 10
) {
  return (dispatch) => {
    dispatch(request());
    connectionsServices
      .applyConnectionsFilters(
        source,
        destination,
        user,
        workspace,
        startDate,
        endDate,
        search,
        offset,
        limit
      )
      .then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
        },
        (error) => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };
  function request() {
    return { type: connectionsConstants.GET_ALL_CONNECTIONS_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.GET_ALL_CONNECTIONS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: connectionsConstants.GET_ALL_CONNECTIONS_FAILURE, error };
  }
}

function activateConnection(isActive, connectionId) {
  return (dispatch) => {
    dispatch(request());
    connectionsServices.activateConnection(isActive, connectionId).then(
    (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: connectionsConstants.ACTIVATE_CONNECTION_REQUEST };
  }
  function success(data) {
    return {
      type: connectionsConstants.ACTIVATE_CONNECTION_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: connectionsConstants.ACTIVATE_CONNECTION_FAILURE, error };
  }
}
